import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ChipsArray from "./ChipsArray";
import MaterialThreeDotMenu from "./MaterialThreeDotMenu";
import { openGlobalDialog } from "../actions/globalEditDialogActions";
import {
	IconBriefcase,
	IconBuilding,
	IconFolderSymlink,
	IconListSearch,
	IconSettings,
	IconShare2,
	IconTag,
	IconTrash,
	IconUsersGroup,
} from "@tabler/icons-react";
import { Flag } from "./Flag";

const subheaderTablerIconProps = {
	size: 24,
	style: { verticalAlign: "sub", marginRight: 8 },
};

const subheaderIconMap = {
	US_FLAG: (
		<span style={{ marginRight: 5 }}>
			<Flag region={"US"} />
		</span>
	),
	CA_FLAG: (
		<span style={{ marginRight: 5 }}>
			<Flag region={"CA"} />
		</span>
	),
	IconTag: <IconTag {...subheaderTablerIconProps} />,
	IconUsersGroup: <IconUsersGroup {...subheaderTablerIconProps} />,
	IconBriefcase: <IconBriefcase {...subheaderTablerIconProps} />,
	IconBuilding: <IconBuilding {...subheaderTablerIconProps} />,
	IconFolderSymlink: <IconFolderSymlink {...subheaderTablerIconProps} />,
	IconTrash: <IconTrash {...subheaderTablerIconProps} />,
	IconSettings: <IconSettings {...subheaderTablerIconProps} />,
	IconListSearch: <IconListSearch {...subheaderTablerIconProps} />,
	IconShare2: <IconShare2 {...subheaderTablerIconProps} />,
};

const SubHeader = (props) => {
	const hasRight = props.chips.length || props.subheaderActions;
	const subheaderTitleMaxWidth = hasRight ? "85%" : "100%";

	const subheaderIcon = subheaderIconMap[props.subheaderIconName]
		? subheaderIconMap[props.subheaderIconName]
		: null;

	if (props.subheaderIconName && !subheaderIcon) {
		console.error(
			`SubHeader: No icon found for subheaderIconName: ${props.subheaderIconName}`
		);
	}

	return (
		<div className="SubHeaderContainer">
			<div
				className="SubHeader"
				style={{
					justifyContent: "space-between",
					width: "100%",
					height: props.subHeaderHeight,
				}}
			>
				<div
					className="SubHeaderTitleContainer"
					style={{
						paddingLeft: subheaderIcon ? 12 : 24,
						maxWidth: subheaderTitleMaxWidth,
					}}
				>
					<div
						className="SubheaderTitle"
						style={{
							textOverflow: "ellipsis",
							whiteSpace: "nowrap",
							overflow: "hidden",
						}}
					>
						{subheaderIcon}
						{props.title}
						{props.title === "Welcome to LexWorkplace" ? (
							<span className="TrademarkSymbol">™</span>
						) : null}
					</div>
				</div>

				<div
					id="chipsDiv"
					style={{
						alignContent: "center",
						paddingRight: 12,
						minWidth: "15%",
					}}
				>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "flex-end",
							gap: 8,
						}}
					>
						{props.chips.length ? (
							<div
								style={{
									display: "flex",
									alignItems: "center",
								}}
							>
								<div
									style={{
										textOverflow: "ellipsis",
										whiteSpace: "nowrap",
										overflow: "hidden",
									}}
								>
									<ChipsArray
										chips={props.chips}
										ignoreRootClass
									/>
								</div>

								<div>
									<MaterialThreeDotMenu
										position={"relative"}
										buttonContent={"..."}
										menuItems={[
											{
												text: "See all tags",
												onSelect: () =>
													props.openGlobalDialog(
														{
															label:
																props.title +
																" tags:",
															mainText: (
																<ChipsArray
																	chips={
																		props.chips
																	}
																/>
															),
															canSubmit: true,
															hideTextfield: true,
															readOnly: true,
															cancelButtonLabel:
																"Ok",
														},
														null,
														() => ({
															canSubmit: true,
														})
													),
											},
										]}
									/>
								</div>
							</div>
						) : null}
						{props.subheaderActions ? props.subheaderActions : null}
					</div>
				</div>
			</div>
		</div>
	);
};

SubHeader.propTypes = {
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	loading: PropTypes.bool.isRequired,
};
const mapStateToProps = (state) => ({
	title: state.currentPage.title,
	subheaderIconName: state.currentPage.subheaderIconName,
	subHeaderHeight: state.currentPage.subHeaderHeight,
	chips: state.currentPage.chips,
	subheaderActions: state.currentPage.subheaderActions,
	loading: state.request.loading,
});
export default connect(mapStateToProps, { openGlobalDialog })(SubHeader);
